import { MarkerPropertiesInterface } from "modules/construction-work/src/Common/interface";
import { DEFAULT_COLOR } from "modules/construction-work/src/Common/const/MarkerConfigsConst";
import {
    Map,
    Marker,
    Polygon,
    VectorLayer,
    OverlayLayer,
} from "maptalks";
import GeometryRendererAbstract from 'modules/construction-work/src/Entity/Map/GeometryRendererAbstract'

export default class PolygonRenderer extends GeometryRendererAbstract {
    render(geometry: Polygon, markerLayer: VectorLayer, map: Map): void {
        const properties = (geometry as any).properties as MarkerPropertiesInterface;
        const fillColor = properties.settingsMarker?.fillColor || DEFAULT_COLOR;

        let svgMap = properties.settingsMarker?.svgMap;

        if (!svgMap){
            svgMap = properties.settingsMarker?.imgMap;
        }

        if (svgMap) {
            const markerSymbols = this.buildMarkerSymbols(
                properties,
            );

            const marker = new Marker(geometry.getCenter(), {
                symbol: markerSymbols,
                properties,
            });
            markerLayer.addGeometry(marker);
        }

        geometry.setSymbol(this.createLineSymbol(fillColor, 1));
        geometry.addTo(map.getLayer('p') as OverlayLayer);
    }
}
